// Main exports for the bridge module
export {
  ANDROID_SOCIAL_LOGIN_SUPPORTED,
  BridgeApi,
  NATIVE_SHARE_SUPPORTED,
  OAUTH_SESSION_SUPPORTED,
} from './BridgeApi';
export type {
  ActorIdPayload,
  AnalyticsDebugPayload,
  BridgeApiConstructorType,
  BridgeDeliveryReport,
  BridgeDeliveryReporter,
  NativeScreen,
  OpenOAuthSessionPayload,
  ReferralOrderCompletedPayload,
  ReferralPromptReadyPayload,
  ShareTextPayload,
} from './BridgeApi';

// Type exports
export type {
  BridgeCallback,
  BridgeMessage,
  BridgeRequest,
  FeatureFlags,
  FromNativeActionName,
  FromNativeActions,
  FromWebActionName,
  FromWebActions,
  OpenUrl,
  SendMessageToNative,
  SendMessageToWeb,
  BridgeHandler,
  BridgeHandlers,
} from './types';

// Utility function exports
export { buildBridgeMessage, buildNativeMessage } from './types';

// Utility exports
export { getBase64Image, isValidImageUri, createWebBridgeApi } from './utils';

// Event bridge for host → app custom events (e.g., WordPress → React)
export { WpBridge, wpBridge, WP_EVENT_CHANNEL } from './WpBridge';
